export function buildMetadataEntityParams(entityType, nodeId, extraParams = {}) {
  return {
    entity_type: entityType,
    node_id: nodeId,
    ...extraParams,
  };
}

export function normalizeMetadataKey(rawKey = {}) {
  const latestVersion = rawKey.latest_version || rawKey.latestVersion || null;

  return {
    ...rawKey,
    key: rawKey.key ?? rawKey.name ?? "",
    name: rawKey.name ?? rawKey.key ?? "",
    value_type: rawKey.value_type ?? latestVersion?.value_type ?? "string",
    unit: rawKey.unit ?? latestVersion?.unit ?? "",
    default: rawKey.default ?? rawKey.is_default ?? false,
    is_default: rawKey.is_default ?? rawKey.default ?? false,
    default_value:
      rawKey.default_value ??
      latestVersion?.default_value ??
      latestVersion?.value ??
      null,
    md_list_id: rawKey.md_list_id ?? rawKey.metadata_list_id ?? null,
    metadata_list_id: rawKey.metadata_list_id ?? rawKey.md_list_id ?? null,
    version: rawKey.version ?? latestVersion?.version ?? rawKey.key_version_id ?? null,
    sort_order: rawKey.sort_order ?? 0,
  };
}

export function normalizeMetadataValue(rawValue = {}) {
  return {
    ...rawValue,
    value:
      rawValue.value ??
      rawValue.value_text ??
      rawValue.value_number ??
      rawValue.value_boolean ??
      rawValue.value_datetime ??
      null,
  };
}

export function normalizeMetadataKeyValue(entry = {}) {
  const key = normalizeMetadataKey(entry.key || entry);
  const valueRecord = normalizeMetadataValue(entry.value || entry);

  return {
    ...entry,
    id: valueRecord.id ?? valueRecord.node_metadata_id ?? key.id ?? null,
    key,
    valueRecord,
    name: valueRecord.name ?? key.name ?? key.key ?? "",
    keyName: key.name ?? key.key ?? "",
    unit: valueRecord.unit ?? key.unit ?? "",
    value_type: valueRecord.value_type ?? key.value_type ?? "string",
    value: valueRecord.value,
    metadata_list_id: key.metadata_list_id ?? valueRecord.metadata_list_id ?? null,
    sort_order: valueRecord.sort_order ?? key.sort_order ?? 0,
    version: key.version ?? valueRecord.key_version_id ?? null,
    is_default: key.is_default ?? false,
    original_md_key_id: key.id ?? valueRecord.metadata_key_id ?? entry.original_md_key_id ?? null,
    snapshot_key_id: key.version ?? valueRecord.key_version_id ?? entry.snapshot_key_id ?? null,
    node_metadata_id: valueRecord.node_metadata_id ?? entry.node_metadata_id ?? null,
    md_value_id: valueRecord.id ?? entry.id ?? null,
  };
}

export function normalizeMetadataKeyCollection(keys = []) {
  return (Array.isArray(keys) ? keys : []).map((key) => normalizeMetadataKey(key));
}

export function normalizeMetadataKeyValueCollection(entries = []) {
  return (Array.isArray(entries) ? entries : []).map((entry) => normalizeMetadataKeyValue(entry));
}
